var stoppableMediaClasses = [];

export function registerStoppableMedia(media) {
  stoppableMediaClasses.push(media);
}

export function stopAllMedia() {
  stoppableMediaClasses.forEach(function (stoppable) {
    return stoppable.stopAll();
  });
}

// functions below are useful as a helpers for some players
//  to implement stopAll

var stoppablePlayers = [];

export function addStoppablePlayer(player) {
  stoppablePlayers.push(player);
}

export function removeStoppablePlayer(player) {
  var playerNdx = stoppablePlayers.indexOf(player);
  if (playerNdx !== -1) {
    stoppablePlayers.splice(playerNdx, 1);
  }
}

export function getStoppablePlayers(type) {
  return stoppablePlayers.filter(function (player) {
    return player instanceof type;
  });
}